import styled from 'styled-components';

// A template name with no spaces still breaks, so it cannot run past the menu's width cap.
export const TemplateName = styled.span`
  overflow-wrap: anywhere;
`;
